import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
function ManufacturerViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Name())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };

    // Send Info Message if Dublicate Value is found.
    self.Save = function (){
        const self: any = this;
        self.TabPage.IsLoading(true);
        return Bao.post(self.SaveUrl, JSON.stringify({
            model: self.MinimizeEntity()
        }), (value) => {
            if (value.Result == false) {
                new BaoDialogViewModel(Bao.Session.ApplicationName, value.Message, "info");
                self.TabPage.IsLoading(false);
            } else {
                self.SaveTime(value.Result);
                self.PerformRefresh();
            }
        });
    }
}
Bao.inherit(ManufacturerViewModel, SearchPaging);
ManufacturerViewModel.prototype.PrimaryKey = "ManufacturerId";
ManufacturerViewModel.prototype.RefreshUrl = "Manufacturer/GetManufacturer";
ManufacturerViewModel.prototype.SaveUrl = "Manufacturer/SaveManufacturer";
ManufacturerViewModel.prototype.DeleteUrl = "Manufacturer/DeleteManufacturer";
ManufacturerViewModel.prototype.IsInUseUrl = "Manufacturer/IsManufacturerInUse";
ManufacturerViewModel.prototype.PermissionForward = "ManufacturerMoveForwardSearch";
ManufacturerViewModel.prototype.PermissionBackward = "ManufacturerMoveBackwardSearch";
ManufacturerViewModel.prototype.PermissionSave = "ManufacturerSave";
ManufacturerViewModel.prototype.PermissionRefresh = "ManufacturerRefresh";
ManufacturerViewModel.prototype.PermissionDelete = "ManufacturerDelete";
export default ManufacturerViewModel;